import React from 'react';
import { graphql, useFragment, useLazyLoadQuery } from 'react-relay';
import { EGiftCardRewardsQuery } from './__generated__/EGiftCardRewardsQuery.graphql';
import RedemptionOptionItem from 'components/organisms/RedemptionOptions/RedemptionOptionItem';
import classes from './EGiftCardRewards.module.scss';
import { CASHOUT, REWARDS } from 'components/pages/pages';
import { useTenant } from 'hooks/useTenant';
import A from 'components/atoms/A/A';
import ChevronIcon from 'components/assets/ChevronIcon';
import Txt from 'components/atoms/Txt/Txt';

export interface Props {}

const query = graphql`
  query EGiftCardRewardsQuery($redemptionType: RedemptionTypeKey!) {
    redemptionOptions(input: { redemptionType: $redemptionType }) {
      edges {
        node {
          id
          name
          amountDenominations {
            panelistCost {
              subUnitAmount
            }
          }
          ...useRedemptionOptionItemQuery_optionRef
        }
      }
    }
  }
`;

export default function EGiftCardRewards() {
  const tenant = useTenant();
  const backPath = tenant === 'mobiworkx' ? REWARDS.path : CASHOUT.path;
  const redemptionOptions = useLazyLoadQuery<EGiftCardRewardsQuery>(
    query,
    { redemptionType: 'GIFT_CARD' },
    {
      fetchPolicy: 'store-and-network',
    },
  );

  return (
    <div className={classes.root}>
      <div className={classes.infoContent}>
        <A className={classes.backLink} href={backPath} aria-label="Back to Rewards">
          <ChevronIcon className={classes.backLinkChevron} />
        </A>
        <Txt component={'h1'} className={classes.title}>
          E-Gift Cards
        </Txt>
        <Txt component={'p'} className={classes.description}>
          Choose your gift card provider from the options below
        </Txt>
      </div>

      <ul className={classes.rewardList}>
        {/* We can re-add filters when necessary (see RedemptionOptions in LP repo) */}
        {redemptionOptions?.redemptionOptions?.edges.map(({ node }) => (
          <RedemptionOptionItem redemptionType={'GIFT_CARD'} key={node.id} optionRef={node} />
        ))}
      </ul>
    </div>
  );
}
